<style lang="scss" scoped></style>

<template>
  <div class="container">
    <HeaderTop></HeaderTop>
    <!-- <Header2></Header2> -->
    <router-view></router-view>
      <RightSide></RightSide>
  </div>

</template>

<script>
import HeaderTop from "@/components/base/headerTop2.vue";
import Footer from "@/components/base/footer";
import RightSide from "@/components/base/rightSide";
export default {
  components: {
    // Header2,
    Footer,
    HeaderTop,
      RightSide,
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  computed: {},
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  min-width: 1200px;
  // min-height: 99.9vh;
  /*min-height: calc(100vh - 1px);*/
  box-sizing: border-box;
  padding-bottom: 200px;
  /*padding-top: 100px;*/
}
</style>
